import service from "../util/http";

// 下载导入成本价维护xls,xlsx模板
export const getCostPriceMaintenance = data => {
    return service({
      url: "/manage/gysPriceFillOut/downloadCostPriceMaintenanceTemplateExcel",
      method: "get",
      responseType: 'blob', // 确保响应类型为 blob（二进制数据）
    });
  };
  // 导入成本价维护xls,xlsx 
  export const postCostPriceMaintenanceR = data => {
    return service({
      url: "/manage/gysPriceFillOut/importCostPriceMaintenanceTemplateExcel",
      method: "post",
      responseType: "blob",
      data
    });
  };
    // 导出成本价维护xls,xlsx 
    export const postCostPriceMaintenanceC = data => {
        return service({
          url: "/manage/gysPriceFillOut/exportCostPriceMaintenanceDatas",
          method: "post",
          responseType: "blob",
          data
        });
      };
  // 查询成本价维护xls,xlsx 
  export const postCostPriceMaintenance = data => {
    return service({
      url: "/manage/gysPriceFillOut/viewCostPriceMaintenanceDatas",
      method: "post",
      data
    });
  };

  //编辑数据
  export const editCostPriceMaintenance = data => {
    return service({
      url: "/manage/gysPriceFillOut/updateCostPriceMaintenanceData",
      method: "post",
      data
    });
  };

  //删除数据
  export const deleteCostPriceMaintenance = data => {
    return service({
      url: "/manage/gysPriceFillOut/deleteCostPriceMaintenanceData",
      method: "post",
      data
    });
  };
  //查看历史数据
  export const oldCostPriceMaintenance = data => {
    return service({
      url: "/manage/gysPriceFillOut/historyViewCostPriceMaintenanceDatas",
      method: "post",
      data
    });
  };